import { RawAxiosRequestConfig } from 'axios';

export const commonHttpClientConfig: RawAxiosRequestConfig = {
  timeout: 20000, // 20 sec. - because of slow support system API
  headers: { 'X-Custom-Header': 'SoftwareOneCMP' },
  responseType: 'json',
  xsrfCookieName: 'XSRF-TOKEN-SWO',
  xsrfHeaderName: 'X-XSRF-TOKEN-SWO',
  validateStatus: (status: number) => status >= 200 && status < 300,
};
